'use es6';

import { Record } from 'immutable';
import { BASE_FIELDS } from 'AdsUI/records/reporting/AdWordsGenericAdReportingRecord';
import { parseUrl } from 'hub-http/helpers/url';
export default Record(Object.assign({}, BASE_FIELDS, {
  description2: null,
  headlinePart1: null,
  headlinePart2: null,
  path1: null,
  path2: null,

  getDisplayUrl() {
    if (this.displayUrl) {
      return this.displayUrl;
    }

    return [parseUrl(this.finalUrl).hostname, this.path1, this.path2].filter(Boolean).join('/');
  },

  fullDescription() {
    return [this.description, this.description2].filter(Boolean).join('. ');
  },

  fullHeadline() {
    return [this.headlinePart1, this.headlinePart2].filter(Boolean).join(' - ');
  }

}));